import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=06188a5e&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=06188a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06188a5e",
  null
  
)

export default component.exports